import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { Product } from '@/organisations/models';

import { environment } from '@env';

const EXPERIMENTAL_PRODUCTS: string[] = [];
@Injectable({
    providedIn: 'root',
})
export class ProductService {
    constructor(private http: HttpClient) {}

    /**
     * Retrieves all products
     * @return {Observable<Product[]>} - The product data
     */
    getProducts(): Observable<Product[]> {
        return this.http
            .get<Product[]>(environment.endpoints.products)
            .pipe(
                map<any[], Product[]>(
                    (data) =>
                        data
                            ?.map((p) => new Product().deserialize(p))
                            .filter((prod) => !EXPERIMENTAL_PRODUCTS.includes(prod.name) || environment.showExperimentalFeatures) ?? [],
                ),
            );
    }
}
